module.exports = __webpack_public_path__ + "labioplastika_4_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/labioplastika_4_after.jpg
// module id = 1073
// module chunks = 0